import { combineReducers } from 'redux'

import { reducer as addIdentityRegionale } from './addIdentityRegionale'
import { reducer as getIdentityRegionale } from './getIdentityRegionale'
import { reducer as updateIdentityRegionale } from './updateIdentityRegionale'

export default combineReducers({
    addIdentityRegionale,
    getIdentityRegionale,
    updateIdentityRegionale,
})
